import React from 'react'
import Icon, { IconName } from '@dustin-web/microsite-components/src/icon'
import Button from '@dustin-web/microsite-components/src/button'

type Props = {
  icon: IconName
  title: string
  description: string
  btnText: string
  btnUrl: string
}

export const CardIconBlock = ({ icon, title, description, btnText, btnUrl }: Props) => {
  return (
    <div className="card-icon">
      {icon && <Icon name={icon} className="i-30" />}
      {title ? <h3 className="card-icon__title">{title}</h3> : null}
      {description ? (
        <div className="card-icon__desctiption" dangerouslySetInnerHTML={{ __html: description }} />
      ) : null}
      {btnText || btnUrl ? (
        <div className="card-image__btn-wrap">
          <Button
            className="card-icon__btn"
            link
            href={btnUrl || ''}
            text={btnText}
            icon="arrow-right"
          />
        </div>
      ) : null}
    </div>
  )
}
